import { format } from 'date-fns';
import { enUS, es } from 'date-fns/locale';
import capitalizeFirstLetter from '../helpers/capitalizeFirstLetter';
import formatDateStringToObject from './formatDateStringToObject';
/**
 * Formats 'yyyy-MM-dd' date, or Date Object, to display string based off the formatted string
 * @param {string | Date} date - either a string of a date or Date object
 * @param {string} formatString - how the return string should look
 * @param {'en' | 'es'} language - either an 'en' or 'es' supported language
 */
const formatDisplayDateWithFormat = (date, formatString, language = 'en') => {
    const localeLang = language === 'es' ? es : enUS;
    if (typeof date === 'string') {
        return capitalizeFirstLetter(format(formatDateStringToObject(date), formatString, {
            locale: localeLang
        }));
    }
    return capitalizeFirstLetter(format(date, formatString, { locale: localeLang }));
};
export default formatDisplayDateWithFormat;
